export default __webpack_public_path__ + "static/media/ana_gil.ee9234e7.png";